const mutationTypes = {
  SET_LOADING: 'SET_LOADING',
  SET_FILES: 'SET_FILES',
  SET_FILES_FILTER: 'SET_FILES_FILTER'
}

const actionTypes = {
  DISPLAY_ERROR: 'DISPLAY_ERROR',
  FETCH_FILES: 'FETCH_FILES',
  DELETE_FILE: 'DELETE_FILE',

  UPDATE_FILENAME: 'UPDATE_FILENAME',

  UPDATE_FILE_TAGS: 'UPDATE_FILE_TAGS',
  UPDATE_FILE_CATEGORY: 'UPDATE_FILE_CATEGORY',
  DOWNLOAD_FILE: 'DOWNLOAD_FILE',
}

export {mutationTypes, actionTypes}



// WEBPACK FOOTER //
// ./src/store/modules/DatenpoolFilesTypes.js